module.exports = __webpack_public_path__ + "img/thankspeople.91d6df1a.png";